import React, {ReactNode} from "react";
import {Box, Tooltip} from "@mui/material";
import {Link} from "react-router-dom";
import {
	BuildCircle,
	Calculate,
	ChevronRight,
	ContentPasteSearch,
	DisplaySettings,
	Email,
	ExpandMore,
	FolderShared,
	Home,
	Inventory,
	Language,
	ListAlt,
	LocalActivity,
	MoneySharp,
	Newspaper,
	QueryStats,
	Quiz,
	SettingsApplications,
	SettingsSuggest,
	Textsms,
	Translate,
	Tune,
	ViewWeek,
	Work,
	Topic, AdminPanelSettings, BadgeOutlined, Policy, Grading, AppRegistration, ElectricBolt, Euro, People, ConfirmationNumberSharp, Compare,
} from "@mui/icons-material";
import {
	isAuthorizedByAnyGroup,
	isAuthorizedByAnyPermission,
} from "../../pages/fragments/PageAuthorization";
import {buildInfo} from "../../global/BuildInfo";
import {GlobalState} from "../../global/GlobalState";
import {TreeItem, TreeView} from "@mui/lab";
import {translateFunction} from "../../localization/TranslationService";
import {permissions} from "../../global/Permissions";

const translate = translateFunction();

export function Sidebar() {
	return <Box
		sx={{
			borderRight: 1,
			borderColor: "grey.500",
		}}
		style={{
			display: "flex",
			flexDirection: "column",
			minWidth: "250px",
		}}
	>
		<TreeView
			defaultCollapseIcon={<ExpandMore/>}
			defaultExpandIcon={<ChevronRight/>}
			style={{flexGrow: 1}}
		>
			{menuItem(new SidebarLink("Home", "/", <Home/>))}
			{menuItem(
				new SidebarLink(
					"Authorization",
					"/authorization",
					<AdminPanelSettings/>,
					[],
					[permissions.authorizationRead],
					[
						new SidebarLink("Policies", "/authorization/policies", <BadgeOutlined/>),
						new SidebarLink("Policy Usages", "/authorization/policyusages", <Policy/>),
						new SidebarLink("Deploy", "/authorization/deploy", <ViewWeek/>),
					]
				)
			)}
			{menuItem(
				new SidebarLink(
					translate("Orders"),
					"/orders",
					<Euro/>,
					["Admin", "Order"]
				)
			)}
			{menuItem(
				new SidebarLink("Messaging", "/messaging/email", <Email/>, [
					"Admin",
					"MailEx",
				])
			)}
			{menuItem(
				new SidebarLink(
					"QueryTool",
					"/querytool",
					<BuildCircle/>,
					["Admin", "QueryToolUser"],
					[],
					[
						new SidebarLink(
							"Job Definitions",
							"/querytool/jobdefinitions",
							<ListAlt/>
						),
						new SidebarLink("Job Runs", "/querytool/job-runs", <ListAlt/>),
					]
				)
			)}
			{menuItem(
				new SidebarLink("Documents", "/documents", <Topic/>, [
					"Documents",
				])
			)}
			{menuItem(
				new SidebarLink(
					"Documents Admin",
					"/documents/admin",
					<SettingsApplications/>,
					["Admin"],
					[],
					[
						new SidebarLink("Settings", "/documents/admin/settings", <SettingsApplications/>, ["Admin"]),
						new SidebarLink("Configuration Sets", "/documents/admin/sets", <Tune/>, ["Admin"]),
						new SidebarLink("Lookup Lists", "/documents/admin/lookups", <ListAlt/>, ["Admin"]),
					]
				)
			)}
			{menuItem(
				new SidebarLink(
					"Monitoring",
					"/monitoring",
					<QueryStats/>,
					["Admin", "Monitoring"],
					[],
					[
						new SidebarLink(
							"Comparisons",
							"/monitoring/comparisons",
							<Calculate/>
						),
					]
				)
			)}
			{menuItem(
				new SidebarLink(
					"Dynamic Forms",
					"/dynamicforms",
					<DisplaySettings/>,
					["Admin", "DynamicForms"],
					[],
					[
						new SidebarLink("Forms", "/dynamicforms/forms", <ListAlt/>),
						new SidebarLink("Questions", "/dynamicforms/questions", <Quiz/>),
						new SidebarLink("Deploy", "/dynamicforms/deploy", <ViewWeek/>),
					]
				)
			)}
			{menuItem(
				new SidebarLink(
					"Products Catalog",
					"/products",
					<Inventory/>,
					["Admin", "Product"],
					[],
					[
						new SidebarLink(
							"Suppliers",
							"/products/suppliers",
							<FolderShared/>
						),
						new SidebarLink("Products", "/products/products", <Work/>),
						new SidebarLink(
							"Comparator Configs",
							"/products/comparatorconfigs",
							<SettingsSuggest/>
						),
						new SidebarLink(
							"Incentives",
							"/products/incentives",
							<ConfirmationNumberSharp/>
						),
						new SidebarLink(
							"Partner Hierarchy",
							"/products/partnerhierarchy",
							<People/>
						),
						new SidebarLink(
							"Custom attribute setup",
							"/products/custom_attribute_setup",
							<LocalActivity/>
						),
						new SidebarLink(
							"Custom attributes for Products",
							"/products/custom_attribute_bulk_products",
							<LocalActivity/>
						),
						new SidebarLink(
							"Custom attributes for Suppliers",
							"/products/custom_attribute_bulk_suppliers",
							<LocalActivity/>
						),
						new SidebarLink("Deploy", "/products/deploy", <ViewWeek/>),
					]
				)
			)}
			{menuItem(
				new SidebarLink(
					"Translation Setup",
					"/translations_setup",
					<Translate/>,
					["Admin", "Translations"],
					[],
					[
						new SidebarLink(
							"Modules",
							"/translations_setup/modules",
							<SettingsApplications/>
						),
						new SidebarLink(
							"Phrases",
							"/translations_setup/phrases",
							<Textsms/>
						),
						new SidebarLink(
							"Translations",
							"/translations_setup/translations",
							<Language/>
						),
						new SidebarLink(
							"Approval Queue",
							"/translations_setup/approval-queue",
							<Grading/>
						),
						new SidebarLink(
							"Deploy",
							"/translations_setup/deploy",
							<ViewWeek/>
						),
					]
				)
			)}
			{menuItem(
				new SidebarLink(
					"Reports",
					"/reports",
					<Newspaper/>,
					["Admin", "Product", "Order"],
					[],
					[
						new SidebarLink(
							"Products commission setup",
							"/reports/products_incentive_setup_report",
							<MoneySharp/>,
							["Admin", "Product"],
						),
						new SidebarLink(
							"Incentive register report",
							"/reports/incentive_register_report",
							<AppRegistration/>,
							["Admin", "Order"],
						),
						new SidebarLink(
							"Custom orders report",
							"/reports/custom_orders_report",
							<ContentPasteSearch/>,
							["Admin", "Order"]
						),
						new SidebarLink(
							"Energy auction report",
							"/reports/energy_auction_report",
							<ElectricBolt/>,
							["Admin", "Energy"]
						),
						new SidebarLink(
							"Comparator intakes report",
							"/reports/comparator_intakes_report",
							<Compare/>,
							["Admin", "Product"]
						)
					]
				)
			)}
		</TreeView>
		<Tooltip
			title={
				<div>
					<table>
						<tbody>
							<tr>
								<td>{translate("Version")}</td>
								<td>{buildInfo.version}</td>
							</tr>
							<tr>
								<td>{translate("Built")}</td>
								<td>
									{GlobalState.formatDateTimeShort(buildInfo.buildMoment)}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			}
			placement={"top-end"}
		>
			<div style={{padding: "3px", textAlign: "right"}}>
				v{buildInfo.version}
			</div>
		</Tooltip>
	</Box>;
}

function menuItem(link: SidebarLink): ReactNode {
	if (link.requiredGroups.length > 0)
		if (!isAuthorizedByAnyGroup(link.requiredGroups))
			// user is not authorized, but authorization is required
			return [];
	if (link.requiredPermissions.length > 0)
		if (!isAuthorizedByAnyPermission(link.requiredPermissions))
			// user is not authorized, but authorization is required
			return [];
	
	return <TreeItem
		key={link.url}
		nodeId={link.url}
		label={
			<Link
				to={link.url}
				style={{
					padding: "8px 0",
					color: "inherit",
					textDecoration: "inherit",
					display: "flex",
					gap: "8px",
				}}
			>
				{link.iconComponent}
				{translate(link.name)}
			</Link>
		}
	>
		{link.children.map(menuItem)}
	</TreeItem>;
}

class SidebarLink {
	constructor(
		readonly name: string,
		readonly url: string,
		readonly iconComponent: JSX.Element,
		readonly requiredGroups: string[] = [],
		readonly requiredPermissions: string[] = [],
		readonly children: SidebarLink[] = [],
	) {
	}
}
